import { InfraType } from 'app/agriculture/mutations/types/entityConfig';
import {
    isBillboardEntityType,
    isPolygonEntityType,
    isPolyLineEntityType,
} from 'app/agriculture/models/Entities';
import { GeometryType } from 'app/agriculture/queries/types/geometry/GeometryType';

export function getGeometryType(infraType: InfraType): GeometryType {
    if (isBillboardEntityType(infraType)) return 'Point';
    if (isPolyLineEntityType(infraType)) return 'LineString';
    if (isPolygonEntityType(infraType)) return 'Polygon';

    // this code should only run if InfraType is expanded to include a new type that isn't covered by
    // the above typeguards, at which point `infraType` will no longer be a 'never' type.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    throw new Error(`Unable to find geometry type for "${infraType}"`);
}
